import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService.js'; // import ResizeObserver polfyfill for IE 11 and Edge<19

import { ResizeObserver as ResizeObserverFallback } from '@juggle/resize-observer';
import { vuetifyColors, getContrastYIQ } from '../../utils/themes';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'CoreAnnouncements',
  computed: _objectSpread(_objectSpread({}, mapState('app', ['announcements'])), mapGetters({
    sessionUser: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })),
  updated: function updated() {
    if (this.$refs.announcementsBanners) {
      // check if browser supports ResizeObserver natively
      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      } else {
        new ResizeObserverFallback(this.onResizeBannerWrapper).observe(this.$refs.announcementsBanners);
      }
    }
  },
  methods: {
    closeAnnouncement: function closeAnnouncement(announcement) {
      var announcementId = announcement.id;
      var userAnnouncements = get(this.sessionUser, 'properties.announcements', []);
      var index = this.$store.state.app.announcements.findIndex(function (announcement) {
        return announcement.id === announcementId;
      });
      this.$store.state.app.announcements.splice(index, 1);

      if (announcementId) {
        set(this.sessionUser, 'properties.announcements', userAnnouncements.filter(function (a) {
          return parseInt(a) !== parseInt(announcementId);
        }));
        this.updateUser(this.sessionUser);
      }
    },
    updateUser: function updateUser(userData, announcement) {
      var _this = this;

      return ApiService.updateUser(userData).then(function () {
        _this.updateAnnouncementState(announcement);
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateAnnouncementState: function updateAnnouncementState(announcement) {
      return ApiService.tenantUpdateSystemAnnouncementState(this.tenantId, announcement);
    },
    showInfoBanner: function showInfoBanner(announcement) {
      if (!announcement.active || announcement.presentationType !== 'banner') {
        return false;
      }

      var now = new Date();
      var startDate = new Date(announcement.start);
      var endDate = new Date(announcement.end);
      return (announcement.start === null || startDate <= now) && (announcement.end === null || endDate >= now);
    },
    getColor: function getColor(type) {
      return vuetifyColors[type] || vuetifyColors['info'];
    },
    getTextColor: function getTextColor(type) {
      return getContrastYIQ(this.getColor(type), '#333');
    },
    getTypeIcon: function getTypeIcon(type) {
      switch (type) {
        case 'info':
          return 'info-circle';

        case 'success':
          return 'check-circle';

        case 'warning':
          return 'exclamation';

        case 'error':
          return 'exclamation-triangle';
      }

      return 'info-circle';
    },
    onResizeBannerWrapper: function onResizeBannerWrapper() {
      if (this.$refs.announcementsBanners && (this.$refs.announcementsBanners.clientHeight || this.$refs.announcementsBanners.clientHeight === 0)) {
        this.$store.state.app.bannerHeight = this.$refs.announcementsBanners.clientHeight;
      }
    }
  }
};